// Shared component styles. Preserve selector order, style values, and caller overrides.
export const drawerStyles = {
  closeButton: ({
    closeColor
  }) => ({
    width: 22,
    height: 22,
    borderRadius: "50%",
    backgroundColor: closeColor,
    // ✅ purple background like screenshot
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: closeColor,
      opacity: 0.9
    }
  }),
  paper: ({
    width,
    paperSx
  }) => ({
    width: {
      xs: "100vw",
      sm: width
    },
    maxWidth: "100vw",
    borderRadius: {
      xs: "0",
      sm: "16px 0 0 16px"
    },
    overflow: "hidden",
    boxShadow: "0 18px 45px rgba(2, 6, 23, 0.22)",
    ...paperSx
  }),
  root: () => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    backgroundColor: "#fff"
  }),
  header: () => ({
    flex: "0 0 auto",
    px: 2,
    py: 1.25,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #EEF2F7",
    backgroundColor: "#fff"
  }),
  headerLeft: () => ({
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: 1
  }),
  headerRight: () => ({
    display: "flex",
    alignItems: "center",
    gap: 1
  }),
  closeIcon: () => ({
    transform: "rotate(45deg)",
    display: "block"
  }),
  content: () => ({
    flex: "1 1 auto",
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    px: 2,
    py: 2,
    WebkitOverflowScrolling: "touch"
  }),
  footer: () => ({
    flex: "0 0 auto",
    borderTop: "1px solid #EEF2F7",
    backgroundColor: "#fff",
    px: 2,
    py: 1.25
  })
};
